import styled from "styled-components";




const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  span {
    img{
        margin-top: -8px;
        margin-left: -4px;
        z-index:1;
        position:relative;
    }
    &.step {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      border: 2px solid #9D99BF;
      position: relative;
    }
    &:not(:last-child):after {
      content: '';
      width: 31px;
      height: 2px;
      background: #9D99BF;
      position: absolute;
      top: 0px;
      left: 0px;
    }
    &.active.step {
      background: #9D99BF;
      border: 2px solid #9D99BF;
    }
    &.selected.step {
      background: transparent;
      border: 2px solid #9D99BF;
      color: #9D99BF;
      font-size: 10px;
    }
    &.selected.step:after {
      top: 0px;
      left: 4px;
    }
  }
`;
export const CourseProgressBar = ({
    value, maxValue, color, boxNumber
}) => {

    return (
        <ProgressWrapper color='#9D99BF'>
            {
                Array.from(Array(boxNumber).keys()).map((item, index) => {
                    return (
                        (value === 0 && index === 0) ?
                            <span key={item} className="selected step">
                                <img src='/images/progress.svg' alt="" />
                            </span> :
                            (value === 50 && index === 1) ?
                                <span key={item} className="selected step">
                                    <img src='/images/progress-yellow.svg' alt="" />
                                </span>
                                :
                                (value === 100 && index === 2) ?
                                    <span key={item} className="selected step">
                                        <img src='/images/progress-green.svg' alt="" />
                                    </span>
                                    :
                                    <span key={item} className="step">

                                    </span>
                    );
                })
            }
        </ProgressWrapper>
    );
}






